module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "ContinuousTesting1.fdf53e31.png";